<template lang="pug">

  p#return-copy
    split-text( :type="'words'" :classname="'question-copy'") {{copy}}

</template>

<script>

import { mapState, mapMutations } from 'vuex' 
import TweenMax from 'gsap'
import WebAudioService from 'src/services/WebAudioService'
import ImageService from 'src/services/ImageService'
import Raf from 'src/helpers/Raf'
import SplitText from 'src/components/_utils/SplitText'

export default {

  name: 'return-copy',
  
  components: {
    SplitText
  },
  
  data() {

    return { }
  },
  
  props: {
    copy: String 
  },

  computed: {  },
  
  mounted() {
     this.list = this.$el.querySelectorAll('.question-copy');

    TweenMax.staggerTo(this.list, 1, {
      y: 0, 
      ease: 'Back.easeOut'
    }, 0.02);
  },
  
  beforeDestroy() {},
  
  methods: {
 
    setup: function() {}
  },
  
  watch: { }

}

</script>

<style lang="sass">

  #return-copy
    font-size: 1.8rem;
    letter-spacing: 0;
    padding: 1rem;
    top: 1rem;
    position: absolute;
    text-align: center;

    .step
      position: absolute;
      bottom: 2rem;

      .question-copy
        transform: translate3d(0, 100px, 0);
        line-height: 1.2;
        margin-bottom: 0.5rem;
        display: inline-block !important;
        background: #fdfb41;
        color: #282828;
        padding: 0.5rem

</style> 